<template>
  <div id="app">
    <!-- Desktop Block Page (404 style) -->
    <div v-if="isBlockedDesktop" class="not-found-page">
      <div class="not-found-content">
        <h1>404</h1>
        <p>Page Not Found</p>
        <p class="sub-text">The page you are looking for does not exist.</p>
      </div>
    </div>
    <!-- Normal Content -->
    <router-view v-else />
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'App',
  data() {
    return {
      isBlockedDesktop: false
    }
  },
  mounted() {
    // 检查设备类型并阻止桌面端访问（管理后台除外）
    this.checkDeviceAccess();
    // 获取网站设置
    this.fetchSiteSettings();
    // 检测推广参数
    this.trackReferral();
    // 记录网站访问
    this.trackSiteVisit();
  },
  watch: {
    // 监听路由变化
    '$route'(to) {
      this.checkDeviceAccess();
      this.trackSiteVisit(to.path);
    }
  },
  methods: {
    checkDeviceAccess() {
      const isAdmin = window.location.hash.includes('/admin');
      const isMobile = this.isMobileDevice();
      
      // 如果是桌面端且不是管理后台，则阻止访问
      if (!isMobile && !isAdmin) {
        this.isBlockedDesktop = true;
      } else {
        this.isBlockedDesktop = false;
      }
    },
    isMobileDevice() {
      const ua = navigator.userAgent.toLowerCase();
      // 检测移动设备和平板
      return /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini|mobile|tablet|silk|kindle|playbook/.test(ua);
    },
    async fetchSiteSettings() {
      try {
        const response = await axios.get('/settings');
        if (response.data.siteName) {
          document.title = response.data.siteName;
        }
      } catch (e) {
        console.log('Failed to fetch site settings');
      }
    },
    async trackSiteVisit(path) {
      try {
        await axios.post('/track/site-visit', {
          path: path || window.location.pathname + window.location.hash,
          referer: document.referrer,
          hostname: window.location.hostname  // For custom domain attribution
        });
      } catch (e) {
        // Silently fail - don't disrupt user experience
      }
    },
    async trackReferral() {
      const urlParams = new URLSearchParams(window.location.search);
      const ref = urlParams.get('ref');
      
      if (ref) {
        // 保存推广ID到localStorage
        localStorage.setItem('promoterId', ref);
        
        // 调用API记录访问
        try {
          await axios.post('/track/visit', {
            promoterId: ref
          });
          console.log('Referral tracked:', ref);
        } catch (e) {
          console.log('Failed to track visit:', e.message);
        }
        
        // 清除URL中的ref参数，保持URL干净
        if (window.history.replaceState) {
          const cleanUrl = window.location.pathname + window.location.hash;
          window.history.replaceState({}, document.title, cleanUrl);
        }
      }
    }
  }
}
</script>

<style>
body {
  margin: 0;
  padding: 0;
  background-color: #f7f8fa;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  min-height: 100vh;
}

/* 404 Not Found Page Styles */
.not-found-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #1a1a2e;
  color: #fff;
}
.not-found-content {
  text-align: center;
}
.not-found-content h1 {
  font-size: 120px;
  margin: 0;
  color: #e94560;
  text-shadow: 2px 2px 4px rgba(0,0,0,0.3);
}
.not-found-content p {
  font-size: 24px;
  margin: 10px 0;
  color: #fff;
}
.not-found-content .sub-text {
  font-size: 14px;
  color: #888;
}
</style>

